import { formatDate } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PublisherStatus } from '../../_models/models';

export interface PublisherStatusPillInput {
  status: PublisherStatus | string;
  accountingId: number | string | null;
  statusModificationDate?: string;
  deactivationReason?: string;
}

interface PublisherStatusPillView {
  label: string;
  cssClass: string;
  tooltip: string | null;
}

@Component({
  selector: 'app-publisher-status-pill',
  templateUrl: './publisher-status-pill.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublisherStatusPillComponent {
  @Input() publisher: PublisherStatusPillInput | null = null;

  get pill(): PublisherStatusPillView {
    const row = this.publisher;
    if (!row) {
      return { label: 'Inactive', cssClass: 'inactive-status', tooltip: null };
    }
    if (row.status === PublisherStatus.ACTIVE) {
      return { label: 'Active', cssClass: 'active-status', tooltip: null };
    }
    if (row.status === PublisherStatus.PENDING_ACTIVATION) {
      const tooltip = row.statusModificationDate
        ? `Request sent on ${formatDate(row.statusModificationDate, 'MM/dd/yyyy', 'en-US')}`
        : 'Request sent';
      return { label: 'Pending Activation', cssClass: 'inactive-status', tooltip };
    }
    const cssClass = row.accountingId === null ? 'inactive-status-ligher' : 'inactive-status';
    return { label: 'Inactive', cssClass, tooltip: this.buildInactiveTooltip(row) };
  }

  private buildInactiveTooltip(row: PublisherStatusPillInput): string | null {
    if (!row.statusModificationDate) {
      return null;
    }
    const date = formatDate(row.statusModificationDate, 'MM/dd/yyyy', 'en-US');
    return `Modified at ${date}`;
  }
}
